import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { Title } from 'components/Title';

import Noc from './Noc';
export default function NocreportPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [loanaccountno, setloanaccountno] = useState('');
	return (
		<main id="NocreportPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('nocreport')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <DataSource   apiPath="components_data/loanaccountno_option_list_33"  >
                        {({ response }) => {
                        const dropdownOptions = response?.map(x => ({
                        label: x.loanaccountno || x.label, // adjust field
                        value: x.loanaccountno || x.value
                        })) || [];
                        return (
                        <>
                        <Dropdown
                        name="loanaccountno"
                        value={loanaccountno}
                        onChange={(e) => setloanaccountno(e.value)}
                        options={dropdownOptions}
                        optionLabel="label"
                        optionValue="value"
                        filter   // 🔍 enables search box
                        showClear
                        placeholder="Select a Loan Account"
                        className="w-500"
                        />
                        </>
                        );
                        }}
                    </DataSource>
                </div>
                <div className="">
                    <div>
                        <Noc loanaccountno= {loanaccountno}  /> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
